__turbopack_context__.v({
  "imageGrid": "intrum-module__WhUBzW__imageGrid",
  "page": "intrum-module__WhUBzW__page",
  "storySection": "intrum-module__WhUBzW__storySection",
});
